<template>
  <div>
    <router-view></router-view>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
    <b-table
      striped
      hover
      :items="items"
      :fields="fields"
      :filter="tableFilter"
      head-row-variant="info"
      @row-clicked="navigate($event)"
      primary-key="id_no"
      :per-page="perPage"
      :current-page="currentPage"
    ></b-table>
  </div>
</template>

<script>
export default {
  computed: {
    tableData() {
      const result = this.$store.getters.projectList;
      return result;
    },
  },
  watch: {
    tableData: function() {
      //eslint-disable-next-line no-console
      //console.log('setting table data')
      this.prepareData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let post_url;
      // call api to get list of projects
      if (this.nextUrl == null) {
        post_url =
          this.$store.state.urlPrefix +
          "api/projects/?limit=20&offset=0&search_filter=" +
          this.filter  +'/';
      } else {
        post_url = this.nextUrl;
      }
      //const post_url = this.$store.getters.urlPrefix + "api/projects/";
      const payload = { mutationName: "projectList", url: post_url };
      this.$store.dispatch("genericGetApiCall", payload).then(
        resolve => {
          //eslint-disable-next-line no-console
          console.log("resolved project list call promise" + resolve);
        },
        reject => {
          //eslint-disable-next-line no-console
          console.log("resolved project list call promise" + reject);
        }
      );
      // computed should do the rest for us.}
    },
    prepareData() {
      this.items = this.tableData.results;
      this.rows = this.items.length;
    },
    navigate(data) {
      //eslint-disable-next-line no-console
      //console.log(data);
      const projectId = data.id;
      this.$router.push("/project/" + projectId);
    },
  
  },
  data() {
    return {
      rows: null,
      items: null,
      tableFilter: null,
      perPage: 40,
      currentPage: 1,

      fields: [
        { key: "projectName", sortable: false },
        { key: "typeOfProject", sortable: false },
        { key: "customer", sortable: false },
        {
          key: "startDate",
          sortable: false,
          formatter: key => {
            const date = key.split("-");
            return date[2] + "/" + date[1] + "/" + date[0];
          }
        },
        {
          key: "endDate",
          sortable: false,
          formatter: key => {
            const date = key.split("-");
            return date[2] + "/" + date[1] + "/" + date[0];
          }
        }
      ]
    };
  }
};
</script>

<style scoped></style>
